<template>
  <div>
    <QuantityOfExchange />
  </div>
</template>

<script>
  import QuantityOfExchange from './component/info';

  export default {
    name: 'purchaseReturnAdd',
    components: {
      QuantityOfExchange,
    },
  };
</script>
